import { effect, inject, Injectable, signal } from '@angular/core';
import { DokumentSearchParams } from '@features/dokumenter/dokument-search/dokument-search-params.model';
import { DokumentDatasource } from '@features/dokumenter/dokument.datasource';
import { Dokument } from './dokument.model';
import { SimpleApi } from '@core/api/simple.api';

@Injectable({
  providedIn: 'root',
})
export class DokumentService {
  simpleApi = inject(SimpleApi);
  datasource = inject(DokumentDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedDokument = signal<Dokument | undefined>(undefined);
  activeTab = signal('search');
  helbredsDato = signal<Date>(new Date());
  firstRecordToShow = signal(0);

  searchDokument(searchParams: DokumentSearchParams) {
    this.firstRecordToShow.set(0);
    this.selectedDokument.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  async selectDokumentResultRow(dokument: Dokument) {
    this.selectDokument(dokument);

    if (dokument) {
      this.activeTab.set('detail');
    }
  }

  async selectDokument(dokument: Dokument) {
    const k = await this.datasource.getById(dokument.id!);
    this.selectedDokument.set(k);
  }

  async hentDokument(dokument: Dokument, download = false) {
    const blob = await this.simpleApi.getBlob(
      `/api/admin/dokumenter/${dokument.id}/download`,
      {
        dowload: download,
      }
    );
    const objectUrl = window.URL.createObjectURL(blob);
    if (download) {
      const link = document.createElement('a');
      link.href = objectUrl;
      link.setAttribute(
        'download',
        dokument.dokumentType?.beskrivelse + '.pdf'
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      window.open(objectUrl);
    }
  }
}
